import { PosOptometrist, PosUserEyeInfo } from "../../types/user";

const cellClassName = "border border-gray-300 px-4 py-2";
const tableClassName = "min-w-full table-auto border-collapse border border-gray-200";

export default function EyesInfoDetails({ eyeInfo }: { eyeInfo: PosUserEyeInfo }) {
  function getOptometristName(optometrist?: PosOptometrist) {
    if (!optometrist) return "";
    return `${optometrist.firstName} ${optometrist.lastName}`;
  }

  return (
    <section className="space-y-10 py-2">
      <div className="space-y-10">
        <EyeInfoSection title="HAB. RX" eyeInfo={eyeInfo} rxType="habRx" />
        <EyeInfoSection title="FULL. RX" eyeInfo={eyeInfo} rxType="fullRx" />
        <EyeInfoSection title="ADJUSTED.RX" eyeInfo={eyeInfo} rxType="adjustedRx" />

        <div>
          <h1 className="pb-6">Optometrist: {getOptometristName(eyeInfo?.optometrist)}</h1>
          <h1 className="pb-6">
            Created By: <span className="font-bold">{eyeInfo?.createdByAdminId?.email || "--"}</span>
          </h1>
          {eyeInfo?.remarks && (
            <div className="pb-6">
              <h1 className="pb-2 font-semibold">Remarks:</h1>
              <p className="whitespace-pre-wrap">{eyeInfo.remarks}</p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}

function EyeInfoSection({ title, eyeInfo, rxType }: { title: string; eyeInfo: PosUserEyeInfo; rxType: string }) {
  const columnHeaders = ["Sphere", "Cylinder", "Axis", "ADD", "V.A.", "Prism", "P.D.", "Height"];

  return (
    <article className="space-y-6">
      <EyeInfoTitle title={title} />
      <EyeInfoTable columnHeaders={columnHeaders} eyeInfo={eyeInfo} rxType={rxType} />
    </article>
  );
}

function EyeInfoTable({ columnHeaders, eyeInfo, rxType }: { columnHeaders: string[]; eyeInfo: PosUserEyeInfo; rxType: string }) {
  return (
    <section className="py-2">
      <div className="overflow-x-auto">
        <table className={tableClassName}>
          <thead>
            <tr>
              <th className={cellClassName}>Eye</th>
              {columnHeaders.map((header) => (
                <th key={header} className={cellClassName}>
                  {header}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            <EyeInfoRow label="Right (右)" eyeData={eyeInfo} rxType={rxType} side="Right" />
            <EyeInfoRow label="Left (左)" eyeData={eyeInfo} rxType={rxType} side="Left" />
          </tbody>
        </table>
      </div>
    </section>
  );
}

function EyeInfoRow({ label, eyeData, rxType, side }: { label: string; eyeData: PosUserEyeInfo; rxType: string; side: string }) {
  return (
    <tr>
      <td className={cellClassName}>{label}</td>
      <td className={cellClassName}>{eyeData?.[`${rxType}Sph${side}`] || "--"}</td>
      <td className={cellClassName}>{eyeData?.[`${rxType}Cyl${side}`] || "--"}</td>
      <td className={cellClassName}>{eyeData?.[`${rxType}Axis${side}`] || "--"}</td>
      <td className={cellClassName}>{eyeData?.[`${rxType}Add${side}`] || "--"}</td>
      <td className={cellClassName}>{eyeData?.[`${rxType}Va${side}`] || "--"}</td>
      <td className={cellClassName}>{eyeData?.[`${rxType}Prism${side}`] || "--"}</td>
      <td className={cellClassName}>{eyeData?.[`${rxType}PD${side}`] || "--"}</td>
      <td className={cellClassName}>{eyeData?.[`${rxType}Height${side}`] || "--"}</td>
    </tr>
  );
}

function EyeInfoTitle({ title }: { title: string }) {
  return <div className="bg-slate-200 dark:bg-gray-500 px-2 py-3 text-center font-semibold rounded-md">{title}</div>;
}
